import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $, { data } from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';

class ConversationLog extends Component {
  constructor() {
    super();

    this.state = {
      showAudioPlayer: false,
      selectedRowId: '',
      utteranceDisplayName: '',
      startDate: new Date(),
      selectedDate: new Date(),
      escalatedChecked: false,
      attendedChecked: false,
      unattendedChecked: false,
      data: [{
        id: '',
        text: '',
        userId: '',
        valueType: '',
        description: '',
        valueType: [],
        userId: '',
        displayName: '',
        contactNumber: '',
        preferredLanguage: '',
        escalated: '',
        attendedChecked: '',
        unattendedChecked: '',
        date: '',
        conversationId: '',
        deleteRow: false,
      }],
      utData: [],
      disabled: false,
      editedId: '-1',
      editImageSrc: './assets/images/edit.svg',
      contentEditable: "false",
      showStore: false,
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      queryMobileNumber: null

    }
    this.editImageSrc = "./assets/images/edit.svg";
    this.saveImageSrc = "./assets/images/save.svg";

    this.valueTypeVar = [];
  }

  notifyFailToCreate() {
    toast(<b style={{ color: "red" }}>Oops! Error occurred. \n Please try again</b>, {
      position: "top-center",
      color: "red"

    });
  }

  notifyInvalidMobileNumber() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please enter a valid mobile number
      </b>,
      {
        position: "top-center",
      }
    );
  }

  componentDidMount() {

    var thisController = this;
    var selectedDate = this.state.selectedDate;
    setTimeout(() => {
      thisController.state.utData = [];
      thisController.state.queryMobileNumber = null;
      thisController.setState(thisController.state);
      thisController.fetchConversationLogData(selectedDate);
    }, 300);

    document.addEventListener("projectChanged", function (event) {
      var selectedDate = thisController.state.selectedDate;
      thisController.state.utData = [];
      thisController.state.queryMobileNumber = null;
      thisController.setState(thisController.state);
      thisController.projectId = event.projectId;
      thisController.fetchConversationLogData(selectedDate, event.projectId);
    });

  }

  escalatedChecked = (e) => {
    var conversationLogController = this;
    conversationLogController.state.escalatedChecked = e.target.checked;
    if (!conversationLogController.state.escalatedChecked) {
      conversationLogController.state.attendedChecked = false;
      conversationLogController.state.unattendedChecked = false;
    }
    conversationLogController.state.utData = [];
    conversationLogController.setState(conversationLogController.state);
    var selectedDate = conversationLogController.state.selectedDate;
    conversationLogController.fetchConversationLogData(selectedDate)
  }
  attendedChecked = (e) => {
    var conversationLogController = this;
    conversationLogController.state.attendedChecked = true;
    conversationLogController.state.unattendedChecked = false;
    conversationLogController.state.utData = [];
    conversationLogController.setState(conversationLogController.state);
    var selectedDate = conversationLogController.state.selectedDate;
    conversationLogController.fetchConversationLogData(selectedDate)
  }
  unattendedChecked = (e) => {
    var conversationLogController = this;
    conversationLogController.state.unattendedChecked = true;
    conversationLogController.state.attendedChecked = false;
    conversationLogController.state.utData = [];
    conversationLogController.setState(conversationLogController.state);
    var selectedDate = conversationLogController.state.selectedDate;
    conversationLogController.fetchConversationLogData(selectedDate)
  }
  refreshData = () => {
    var conversationController = this;
    conversationController.state.selectedDate = new Date();
    conversationController.state.escalatedChecked = false;
    var checkbox = document.getElementById('Escalated');
    if (checkbox) {
      checkbox.checked = false;
    }
    conversationController.state.attendedChecked = false;
    conversationController.state.unattendedChecked = false;
    conversationController.state.queryMobileNumber = null;
    var queryMobileNumberInput = document.getElementById('query-mobile-number');
    if (queryMobileNumberInput) {
      queryMobileNumberInput.value = '';
    }
    conversationController.state.utData = [];
    conversationController.setState(conversationController.state);
    conversationController.fetchConversationLogData(conversationController.state.selectedDate);
  }
  onChange = date => {
    this.state.selectedDate = date;
    this.state.utData = [];
    this.setState(this.state);
    this.fetchConversationLogData(date);
  }

  fetchConversationLogData = (selectedDate, projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    let conversationController = this;
    let longDate = new Date(selectedDate.toDateString()).getTime();

    let data = {};
    data.projectId = projectId;
    data.date = longDate;
    data.escalationChecked = conversationController.state.escalatedChecked;
    data.attendedChecked = conversationController.state.attendedChecked;
    data.unattendedChecked = conversationController.state.unattendedChecked;

    if (conversationController.state.queryMobileNumber != null) {
      data.queryMobileNumber = conversationController.state.queryMobileNumber;
    }

    $.ajax({
      url: "/api/conversations",
      async: false,
      method: 'GET',
      data: data,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      success: function (res) {
        if (res.success === true) {
          var tagKeys = res.result;
          conversationController.setState({
            data: tagKeys,
            successResp: true
          })
        }
      },
    });
  }

  fetchUtterancesApi = (id, supportUserName) => {
    var utteranceController = this;

    $.ajax({
      url: "/api/utterances/",
      async: false,
      method: 'GET',
      data: { conversationId: id },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token"), },
      success: function (res) {
        if (res.success === true) {

          var source = { "supervisorUserName": supportUserName };
          var data = [];
          for (var i = 0; i < res.result.length; i++) {
            data[i] = Object.assign(res.result[i], source);
            if (res.result[i].id == id) {
              data[i] = Object.assign(res.result[i], source);

            }
          }
          utteranceController.setState({
            utData: data,
            successResp: true
          });
        } else {
          utteranceController.notifyFailToCreate();
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }

    });
  }
  handleChange = (e) => {
    this.setState({ selectValue: e.target.value });
  }
  handleChangeForUtterance = (id, supportUserName, uxType) => {

    var showAudioPlayer = false;
    if (uxType === "TELEPHONY") {
      showAudioPlayer = true;
      var audioPlayer = document.getElementById("callRecordingPlayer");
      var audioUrl = window.location.protocol + "//" + window.location.host +
        "/api/get-call-recording/" + id + ".mp3";
      audioPlayer.src = audioUrl;
      audioPlayer.load();
    }
    this.setState({
      selectedRowId: id,
      text: this.state.value,
      showAudioPlayer: showAudioPlayer
    });


    this.fetchUtterancesApi(id, supportUserName);
  }

  queryHandleChange = (e) => {
    let mobileNumber = document.getElementById('query-mobile-number').value;
    console.log('Entered mobile number: ' + mobileNumber);
    if (this.validateMobileNumber(mobileNumber)) {
      this.state.queryMobileNumber = mobileNumber;
      this.setState(this.state);
      this.fetchConversationLogData(this.state.selectedDate);
    }
    else {
      this.notifyInvalidMobileNumber();
    }
  }

  validateMobileNumber = (number) => {
    return /^\+?\d+$/.test(number);
  }

  render() {
    const { data } = this.state
    const columns1 = [

      {
        width: 250,
        Header: '',
        minWidth: 17,
        textAlign: 'screenLeft',
        accessor: 'text',
        sortable: false,
        cellStyle: { border: 'none' },
        headerStyle: { marginTop: '-10px' },
        Cell: props =>
        (

          <div class="card-body chat_body log_one" style={{ display: props.original.text != "" ? 'block' : 'none' }}>
            <div className={(props.original.incoming == false) ? "direct-chat-msg" : "direct-chat-msg right "}>
              <div className={(props.original.incoming == false) ? "direct-chat-text chat_left textarea" : "direct-chat-text chat_right textarea"}
                style={{
                  display: props.original.id != "" || props.original.id != undefined ||
                    props.original.id != null || props.original.text != null ? "block" : "none",
                  marginTop: "5px", width: "200%", height: "auto",
                  backgroundColor: props.original.incoming == false ? "#ead5d5" : "#e1e1f5",
                  marginTop: '-10px', borderBottom: 'none',
                  textAlign: props.original.incoming == false ? "left" : "right",
                }}>

                <font id={"text" + props.index} readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false}>
                  {(props.original.supportUserId != null && props.original.incoming == false) ?
                    <p><b>{props.original.supportUserId}:</b> {props.original.text}</p> :
                    props.original.text}
                </font>
              </div>
            </div>
          </div>

        )
      },
    ]

    const columns =
      [
        {
          Header: 'Id',
          accessor: 'id',
          show: false,
          Cell: props => (
            <div name="id" id={"id" + props.index}>{props.original.id}
            </div>)
        },

        {
          Header: () => (''),
          accessor: 'userId',
          sortable: false,
          headerStyle: { marginTop: '-10px' },
          Cell: props => (
            <div name="userId"
              className={this.state.selectedRowId == props.original.id ? "selectedConvEntryInLog" : ""}
            >

              <b>User Name :</b><font
                style={{ color: 'none', border: 'none', background: 'white', resize: 'none', marginLeft: '5px', marginRight: '20px' }}
                id={"displayName" + props.index}>{props.original.displayName}
              </font>
              <b>Start Time :</b><font
                style={{ color: 'none', border: 'none', background: 'white', resize: 'none', marginLeft: '5px' }}
                id={"displayName" + props.index}>{(new Date(props.original.startTime)).toLocaleString()}
              </font><br />
              <b>Contact Number :</b><font
                style={{ border: 'none', background: 'white', resize: 'none', marginLeft: '5px', marginRight: '20px' }}
                id={"contactNumber" + props.index}>{props.original.contactNumber}
              </font >
              <b>Language :</b><font
                style={{ border: 'none', background: 'white', resize: 'none', marginLeft: '6px', marginRight: '25px' }}
                id={"preferredLanguage" + props.index}>{props.original.preferredLanguage}
              </font >

              <b>Escalated : </b><font
                style={{ border: 'none', background: 'white', resize: 'none', marginLeft: '6px', marginRight: '25px' }}
                id={"escalationChecked" + props.index}>{props.original.escalated ? "Yes" : "No"}
              </font ><br />
              <b> Last Supervision By:</b><font
                style={{ border: 'none', background: 'white', resize: 'none', marginLeft: '6px', marginRight: '14px' }}
                id={"userId" + props.index}>{props.original.lastSupportUserId == null ? 'NA' : props.original.lastSupportUserId}
              </font >
              <b>UX Session ID:</b><font
                style={{ border: 'none', background: 'white', resize: 'none', marginLeft: '6px', marginRight: '25px' }}
                id={"userId" + props.index}>{props.original.uxSessionId == null ? 'NA' : props.original.uxSessionId}
              </font ><br />
              <b>Location Lat:</b><font
                style={{ border: 'none', background: 'white', resize: 'none', marginLeft: '6px', marginRight: '25px' }}
                id={"latitude" + props.index}>{props.original.latitude == null ? 'NA' : props.original.latitude}
              </font >
              <b>Location Longt:</b><font
                style={{ border: 'none', background: 'white', resize: 'none', marginLeft: '6px', marginRight: '25px' }}
                id={"longitude" + props.index}>{props.original.longitude == null ? 'NA' : props.original.longitude}
              </font ><br />
              <div Align="right">
                <button className="btn2 table-action-button "
                  title="View conversation"
                  style={{ borderRadius: '4px' }}
                  onClick={() => {
                    this.handleChangeForUtterance(props.original.id, props.original.lastSupportUserId, props.original.uxType);
                  }}
                >View conversation</button>
              </div>
            </div>)
        },
        {
          Header: () => (
            'userId'),
          accessor: 'userId',
          sortable: false,

          show: false,
          Cell: props => (
            <div name="userId">
              <textarea
                style={{ border: 'none', background: 'white', resize: 'none' }}
                id={"userId" + props.index}
                class="form-control"
                rows="1"
                maxlength="250"
                readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.userId}
              </textarea>
            </div>)
        },
        {
          Header: () => (
            'displayName'),
          accessor: 'displayName',
          sortable: false,

          show: false,
          Cell: props => (
            <div name="displayName">
              <textarea
                style={{ border: 'none', background: 'white', resize: 'none' }}
                id={"displayName" + props.index}
                class="form-control"
                rows="1"
                maxlength="250"
                readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.displayName}
              </textarea>
            </div>)
        },


        {
          Header: () => (
            'contactNumber'),
          accessor: 'displayName',
          sortable: false,

          show: false,
          Cell: props => (
            <div name="displayName">
              <textarea
                style={{ border: 'none', background: 'white', resize: 'none' }}
                id={"displayName" + props.index}
                class="form-control"
                rows="1"
                maxlength="250"
                readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.displayName}
              </textarea>
            </div>)
        },

        {
          Header: () => (
            'preferredLanguage'),
          accessor: 'displayName',
          sortable: false,

          show: false,
          Cell: props => (
            <div name="displayName">
              <textarea
                style={{ border: 'none', background: 'white', resize: 'none' }}
                id={"displayName" + props.index}
                class="form-control"
                rows="1"
                maxlength="250"
                readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.displayName}
              </textarea>
            </div>)
        },

        {
          Header: () => (
            'escalationChecked'),
          accessor: 'displayName',
          sortable: false,

          show: false,
          Cell: props => (
            <div name="displayName">
              <textarea
                style={{ border: 'none', background: 'white', resize: 'none' }}
                id={"displayName" + props.index}
                class="form-control"
                rows="1"
                maxlength="250"
                readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.displayName}
              </textarea>
            </div>)
        },

        {
          Header: () => (
            'attendedChecked'),
          accessor: 'attendedChecked',
          sortable: false,

          show: false,
          Cell: props => (
            <div name="attendedChecked">
              <textarea
                style={{ border: 'none', background: 'white', resize: 'none' }}
                id={"attendedChecked" + props.index}
                class="form-control"
                rows="1"
                maxlength="250"
                readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.attendedChecked}
              </textarea>
            </div>)
        },

        {
          Header: () => (
            'date'),
          accessor: 'date',
          sortable: false,

          show: false,
          Cell: props => (
            <div name="date">
              <textarea
                style={{ border: 'none', background: 'white', resize: 'none' }}
                id={"date" + props.index}
                class="form-control"
                rows="1"
                maxlength="250"
                readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.date}
              </textarea>
            </div>)
        },
        {
          Header: () => (
            'conversationId'),
          accessor: 'conversationId',
          sortable: false,

          show: false,
          Cell: props => (
            <div name="conversationId">
              <textarea
                style={{ border: 'none', background: 'white', resize: 'none' }}
                id={"conversationId" + props.index}
                class="form-control"
                rows="1"
                maxlength="250"
                readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false}
              >{props.original.conversationId}
              </textarea>
            </div>)
        },

      ]


    return (
      <div visible={(this.state.successResp) ? false : true}>

        <div style={{
          background: "#F9F9FB", marginLeft: '1%', marginRight: '1%',
        }}>
          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          {/* for reactTable */}
          <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
          <link rel="stylesheet" href="./assets/css/react.table.border.css" />
          {/*for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          {/* <div className="wrapper"> */}
          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | BackEnd Api </title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="plugins/select2/select2.min.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          {/* ----new style------------------------------- */}
          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link rel="stylesheet" href="plugins/select2/select2.min.css" />
          <link rel="stylesheet" href="dist/css/adminlte.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <style media="screen" dangerouslySetInnerHTML={{ __html: "\n    .card-footer {\n      background-color: transparent;\n      padding: 0.75rem 0.25rem;\n    }\n\n    .logtable tbody td:last-child{\n      width: 150px;\n    }\n\n    .logTableBox{\n      overflow: auto !important;\n    }\n  " }} />


          {/* for checkbox component */}
          <link rel="stylesheet" href="./assets/css/combobox-style.css" />
          <link rel="stylesheet" href="assets/css/Checkbox/Checkboxbutton.css" />
          <link rel="stylesheet" href="assets/css/Checkbox/CheckboxTick.css" />


          <div className="container-fluid">
            <div className="row" style={{ marginTop: '0%' }}>
              <div className="col-sm-4">
                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '0%' }}>Conversation Log</h6>
                <h6></h6>
              </div>
            </div>

            {/* Filter options */}
            <div className="row" style={{ marginTop: '0%' }}>
              <div className="col-sm-4" style={{ marginTop: '1%' }} >
                <p>
                  <input type="checkbox" label="Escalated" style={{ accentColor: '#282a65' }} id="Escalated"
                    checked={this.state.escalatedChecked} onClick={this.escalatedChecked} />
                  <label for="Escalated" style={{ marginLeft: '2%', color: 'black' }}>Escalated</label>

                  <input type="radio"
                    style={{ marginLeft: '5%', accentColor: '#282a65' }}
                    disabled={!this.state.escalatedChecked}
                    id="Attended" onClick={this.attendedChecked} value="Attended" checked={this.state.attendedChecked === true} />
                  <label for="Attended"
                    style={{ marginLeft: '2%', color: 'black', opacity: (!this.state.escalatedChecked) ? 0.40 : 1 }}>Attended</label>

                  <input type="radio"
                    style={{ marginLeft: '5%', accentColor: '#282a65' }}
                    disabled={!this.state.escalatedChecked}
                    id="Unattended" onClick={this.unattendedChecked} value="Unattended" checked={this.state.unattendedChecked === true} />
                  <label for="Unattended"
                    style={{ marginLeft: '2%', color: 'black', opacity: (!this.state.escalatedChecked) ? 0.40 : 1 }}>Unattended</label>
                </p>
              </div>

              {/* Refresh button */}
              <div className="col-sm-1 row" style={{ marginTop: '1%', marginLeft: "50rem" }} >
                <button className="btn action-button"
                  style={{ marginTop: '-10px', marginLeft: '5%' }}
                  onClick={this.refreshData}
                  title="Refresh">
                  <img src="./assets/images/refresh_white_24dp.png" />
                </button>
              </div>
            </div>


            <div
              style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "2rem", marginBottom: "1%" }}>

              {/* Date picker */}
              <div className="col-sm-3" style={{ marginLeft: '0%' }}>
                <div className="p" style={{ cursor: "pointer" }}>
                  <b>DATE : <DatePicker
                    style={{ width: '20px', marginLeft: '70%', cursor: "pointer" }}
                    id="date"
                    selected={this.state.selectedDate}
                    onChange={this.onChange}
                    dateFormat="dd/MM/yyyy">
                  </DatePicker>
                  </b>
                </div>
              </div>

              {/* Search bar */}
              <div className="col-sm-4">
                <div className="input-group search-btn" style={{ marginTop: '8px', width: '200px', display: 'inline-block', backgroundColor: 'rgb(249, 249, 251)' }} >
                  <div className="search-icon" >
                    <input className="border-none" type="search" placeholder="Search by mobile"
                      onKeyPress={this.onKeyPressHandleChange} aria-label="Search"
                      style={{
                        width: '77%', height: '80%', filterable: true, backgroundColor: 'rgb(249, 249, 251)',
                        font: 'bold', color: 'black'
                      }} id="query-mobile-number" />
                    <button onClick={this.queryHandleChange} style={{ border: 'none', backgroundColor: '#F9F9FB' }}>
                      <img src="assets/images/search.svg" style={{ width: '18px' }} /></button>
                  </div>
                </div>
              </div>

              {/* Audio controllers */}
              <div
                style={{
                  display: this.state.showAudioPlayer ? "flex" : "none",
                  alignItems: "center",
                  gap: "1rem",
                  borderRadius: "10px",
                  margin: "10px",
                  padding: "6px",
                  height: "auto",
                  textAlign: "center",
                  marginLeft: "-7rem"
                }}
              >
                <audio
                  id="callRecordingPlayer"
                  controlsList="nofullscreen"
                  controls
                  style={{ width: "20vw" }}
                >
                  <source
                    src=""
                    type="audio/mpeg"
                  />
                </audio>

                <a href={`${window.location.protocol}//${window.location.host}/api/download-call-recording?conversationId=${this.state.selectedRowId}`}
                  target='_blank' style={{ padding: "1rem", color: "white", display: "flex", gap: "11px", backgroundColor: "#282a65", borderRadius: "10px" }}>

                  <img src="./assets/images/download-2-white.png" style={{ width: "1.5rem", height: "1.5rem" }} />

                  <span>Download Audio</span></a>
              </div>

            </div>

          </div>
          {/* /.content-header */}
          <div className="content" style={{ marginTop: "10px" }}>
            <div className="container-fluid" >
              <div className="row"
                style={{ marginRight: '2%' }}  >
                <ToastContainer classname="Toast-at-center" />
                <div className="col-lg-6" >
                  <div className="card" style={{ height: "570px", overflowY: data.length > 4 ? "scroll" : "hidden" }}>
                    <div>
                      <ReactTable
                        style={{
                          display: this.state.successResp ? 'block' : 'none',
                        }}
                        data={data}
                        columns={columns}
                        pageSize={data.length > 5 ? data.length : 5}
                        showPagination={false}
                      />
                    </div>
                  </div>
                  {/* <ToastContainer classname="Toast-at-center" /> */}
                </div>
                <div></div>
                <div class="col-lg-6">
                  <div className="card" style={{ height: "570px", overflowY: "auto" }}>
                    <div class="table-responsive logTableBox">
                      <ReactTable id='reactTable'
                        data={this.state.utData}
                        columns={columns1}
                        showPagination={false}
                        pageSize={this.state.utData.length <= 5 ? 5 : this.state.utData.length}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    )
  }
}
export default ConversationLog;



// WEBPACK FOOTER //
// ./src/projectmgmt/reports/conversation/ConversationLog.js